import Card from './Card'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from '../styles/CardHover.module.scss'
import useDarkMode from 'use-dark-mode'
import { useState } from 'react'

const CardHover = (props) => {
  const { left, name, url } = props
  const darkMode = useDarkMode(false)
  const [isHovering, setIsHovering] = useState(false)

  return (
    <span
      className={classNames(styles.text, { [styles.dark]: darkMode.value })}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <span>{url ? <Link to={url}>{name}</Link> : name}</span>
      {isHovering ? (
        <span
          className={classNames(
            styles.hover,
            { [styles.left]: left },
            'shadow'
          )}
        >
          <Card {...props} background hideName />
        </span>
      ) : null}
    </span>
  )
}

CardHover.propTypes = {
  left: PropTypes.bool,
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
}

export default CardHover
